import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Offer from 'components/Calculator/Offer';
import { TwButton } from 'components/TwButton/TwButton';
import H2 from 'components/H/H2';
import H1 from 'components/H/H1';
import { Card, Typography } from '../../../components';
import styles from './Downsale.module.scss';
import OriginalAndNewAmount from './OriginalAndNewAmount';
import useDownsalePage from './useDownsalePage';

export default function Downsale() {
  const { t } = useTranslation('downsale');
  const {
    originalAmount,
    newAmount,
    clientOfferData,
    isPending,
    handleOnSubmit,
  } = useDownsalePage();

  return (
    <>
      <Helmet>
        <title>{t('html_title')}</title>
      </Helmet>

      <H1>{t('title')}</H1>

      <div className="flex flex-col gap-6">
        <p className="text-center lg:text-left px-5 lg:px-0">
          {t('sub_title')}
        </p>

        <OriginalAndNewAmount
          originalAmount={originalAmount}
          newAmount={newAmount}
        />

        <Card className={styles.card}>
          <Typography size="m" className={styles['card-title']}>
            {t('card_title')}
          </Typography>

          <Offer offer={clientOfferData} />
        </Card>

        <div className="px-5 lg:px-0">
          <TwButton
            pending={isPending}
            onClick={handleOnSubmit}
            disabled={isPending || !clientOfferData}
            className="mx-auto lg:mx-0"
          >
            {t('button')}
          </TwButton>

          <H2>{t('info_title')}</H2>

          <span
            dangerouslySetInnerHTML={{
              __html: t('info_text'),
            }}
          />
        </div>
      </div>
    </>
  );
}
